import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-specializes-writing',
  templateUrl: './specializes-writing.component.html',
  styleUrls: ['./specializes-writing.component.scss']
})
export class SpecializesWritingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
